<template>
  <v-container>
    <v-row class="title text-h3 text-uppercase">
      {{ $t('title') }}
    </v-row>
    <v-row justify="center">
      <v-col
        v-for="item in cards"
        :key="item.id"
        class="center-wrap"
        cols="12"
        md="4"
      >
        <router-link
          class="link-pointer router-div"
          :to="item.routerLink"
          tag="div"
        >
          <v-card
            class="ma-auto card-style"
            width="200"
            height="200"
          >
            <v-row>
              <v-icon
                size="110"
                color="primary darken-2"
                class="ma-auto my-5"
              >
                {{ item.icon }}
              </v-icon>
            </v-row>
            <v-row justify="center">
              <v-col class="center-wrap">
                <div>{{ item.text }}</div>
              </v-col>
            </v-row>
          </v-card>
        </router-link>
      </v-col>
    </v-row>
  </v-container>
</template>

<i18n src="./locales/en.json"></i18n>
<i18n src="./locales/zhHant.json"></i18n>

<script>
import ErrorDisplay from '@/components/functions/Common/mixins/ErrorDisplay'

export default {
  name: 'TopIndex',
  mixins: [ErrorDisplay],
  data: function () {
    return {
      cards: [
        { id: 1, text: this.$t('sidebar.userManagement'), icon: 'fa-user', routerLink: 'User' },
        { id: 2, text: this.$t('sidebar.scanRecord'), icon: 'fa-qrcode', routerLink: 'ScanRecord' }
      ]
    }
  },
  computed: {
  },
  mounted () {
    this.$emit('pageName', this.$t('pageName'))
  },
  methods: {
  }
}
</script>

<style scoped>
.title {
  margin: 30px;
  justify-content: center;
  text-align: center;
}

.router-div {
  width: 200px;
  height: 200px
}

.card-style:hover {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.3), 0 6px 20px 0 rgba(0, 0, 0, 0.2);
}
</style>
